import React from 'react';
import { Box, Card, CardContent, CardMedia, Typography, Button, Grid, useTheme, useMediaQuery } from '@mui/material';
import ASE from '../../images/ASE.png';
import ASE1 from '../../images/ASE1.png';
import ASE2 from '../../images/ASE2.png';
import ASE3 from '../../images/ASE3.png';
import ASE4 from '../../images/ASE4.png';

// Import PDF certificates
// Import PDF certificates
import K8sBeginner from '../../images/K8s.pdf';
import K8sMumshad from '../../images/K8s_udemy.pdf';


const certifications = [
  {
    title: "NetApp ASE Certification",
    image: ASE,
    fileUrl: ASE,
    description: "Certification on NetApp storage engineering fundamentals and implementation."
  },
  {
    title: "NetApp ASE 1 Certification",
    image: ASE1,
    fileUrl: ASE1,
    description: "Focused on advanced NetApp system configuration and management."
  },
  {
    title: "NetApp ASE 2 Certification",
    image: ASE2,
    fileUrl: ASE2,
    description: "Specialized in troubleshooting, optimization, and best practices for NetApp environments."
  },
  {
    title: "NetApp ASE 3 Certification",
    image: ASE3,
    fileUrl: ASE3,
    description: "Advanced certification in enterprise storage solutions with NetApp."
  },
  {
    title: "NetApp ASE 4 Certification",
    image: ASE4,
    fileUrl: ASE4,
    description: "Expert-level certification in scalable storage and cloud integration using NetApp."
  },
  {
    title: "Kubernetes for Absolute Beginners",
    image: "https://img.icons8.com/color/96/kubernetes.png",
    fileUrl: K8sBeginner,
    description: "Course completion certificate for Kubernetes for Absolute Beginners."
  },
  {
    title: "Kubernetes for Beginners (Mumshad Mannambeth)",
    image: "https://img.icons8.com/color/96/kubernetes.png",
    fileUrl: K8sMumshad,
    description: "Certification from Mumshad Mannambeth’s Kubernetes for Beginners course."
  }
];

const CertificationsSection = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const cardHeight = isMobile ? 250 : 300;

  return (
    <Box sx={{ flexGrow: 1, padding: 4, backgroundColor: 'white' }}>
      <Typography 
        variant="h4" 
        component="div" 
        gutterBottom 
        sx={{
          fontWeight: 'bold',
          textAlign: 'center',
          fontSize: isMobile ? '30px' : '40px',
          color: 'black',
          marginBottom: '3%'
        }}
      >
        My <span style={{ color: '#f9004d' }}>Certifications</span>
      </Typography>
      
      <Grid container spacing={4}>
        {certifications.map((cert, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Card sx={{
              display: 'flex',
              flexDirection: 'column',
              height: '100%',
              transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
              '&:hover': {
                transform: 'scale(1.05)',
                boxShadow: '0 4px 20px rgba(0,0,0,0.2)'
              }
            }}>
              <CardMedia
                component="img"
                sx={{ height: cardHeight, width: '100%', objectFit: 'cover' }}
                image={cert.image}
                alt={cert.title}
              />
              <CardContent sx={{ flexGrow: 1 }}>
                <Typography variant="h6" component="div" gutterBottom>
                  {cert.title}
                </Typography>
                <Typography variant="body2" color="text.secondary" paragraph>
                  {cert.description}
                </Typography>
                <Button
                  sx={{
                    backgroundColor: 'transparent',
                    color: 'black',
                    border: '1px solid #f9004d',
                    fontSize: isMobile ? '12px' : '15px',
                    '&:hover': {
                      backgroundColor: 'transparent',
                      color: '#f9004d',
                      border: '1px solid black'
                    }
                  }}
                  onClick={() => window.open(cert.fileUrl, "_blank")}
                >
                  View Certificate
                </Button>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default CertificationsSection;
